module.exports = __webpack_public_path__ + "static/8_cro_tips-470e5685b34041b3c4dc76601eaeac4c.png";